import { useQuery } from "@tanstack/react-query"
import { getPunctualityHistory } from "../services/query_service"

export const usePunctualityQuery = () => {
    return useQuery({
        queryKey: ['punctuality', 'history'],
        queryFn: getPunctualityHistory
    })
}